import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import { AnswerProps } from './types';
import { InputEvent } from '../StageZero/types';
import { Skill } from '../../store/missions/types';
import SkillPoints from '../SkillPoints/SkillPoints';
import FeedbackItem from './FeedbackItem';

const Answer: React.FC<AnswerProps> = (props) => {
    const [skills, setSkills] = useState<Skill[]>([]);

    useEffect(() => {
        if (skills.length === 0) setSkills(props.skillsCollection ?? []);
    }, []);

    const updateOption = (e: InputEvent) => {
        const { value } = e.target;
        const currentOption = props.options.find((x) => x.id === props?.id);
        if (currentOption) {
            const modifiedOption = {
                ...currentOption,
                text: currentOption.text
                    ? ({ ...currentOption.text, [props.language]: value } as Record<string, string>)
                    : {},
            };
            props.setOptions(
                props.options.map((option) => {
                    return option.id !== props.id ? option : modifiedOption;
                }),
            );
        }
    };

    return (
        <div>
            <Grid container spacing={2} className="answer-row">
                <Grid item xs={6}>
                    {props.languages.map((lang) => (
                        <TextField
                            fullWidth
                            style={{ display: lang.code === props.language ? 'block' : 'none' }}
                            key={`${props.id}_text_${lang.code}`}
                            defaultValue={props.text?.[lang.code]}
                            variant="outlined"
                            required={false}
                            type="text"
                            id={`${props.id}_text_${lang.code}`}
                            label="Answer"
                            name={`${props.id}_text_${lang.code}`}
                            onChange={updateOption}
                        ></TextField>
                    ))}
                </Grid>
                <Grid item xs={6} className="points-container">
                    {skills?.map((skill) => {
                        return (
                            <SkillPoints
                                key={skill.id}
                                data={skills}
                                id={skill.id}
                                itemId={props.id}
                                language={props.language}
                                defaultValues={props.skills}
                                items={props.options}
                                setItems={props.setOptions}
                            ></SkillPoints>
                        );
                    })}
                </Grid>
                {props.feedbackVisible ? (
                    <Grid item xs={10}>
                        <FeedbackItem option={props.options.find((x) => x.id === props.id)} {...props}></FeedbackItem>
                    </Grid>
                ) : (
                    ''
                )}
            </Grid>
        </div>
    );
};

export default Answer;
